import { useCallback, useRef, useState, Dispatch, SetStateAction } from "react";
import { IBlock } from "../BlockList/Block";
import { filterBlocksBySearch } from "./blockSearchFilter";

/**
 * Hook to manage block search and filtering.
 *
 * The search term is tracked in a ref so that `useBlocksSync` can re-apply the
 * active filter when new batches arrive (progressive folder list load), instead
 * of resetting the visible list to the full (unfiltered) set on every update.
 */
export function useBlockSearch(blocks: IBlock[]): {
	blocksShowing: IBlock[];
	handleSearchChange: (value: string) => void;
	setBlocksShowing: Dispatch<SetStateAction<IBlock[]>>;
	searchValueRef: React.MutableRefObject<string>;
} {
	const [blocksShowing, setBlocksShowing] = useState<IBlock[]>(blocks);
	const searchValueRef = useRef("");

	const handleSearchChange = useCallback(
		(value: string) => {
			searchValueRef.current = value;
			setBlocksShowing(filterBlocksBySearch(blocks, value));
		},
		[blocks],
	);

	return {
		blocksShowing,
		handleSearchChange,
		setBlocksShowing,
		searchValueRef,
	};
}
